import { FiInfo } from 'react-icons/fi';

type Props = {
  projectId?: string | null;
  className?: string;
};

/**
 * Shown on delivery views when no project is selected — avoids silent partial task lists.
 */
export default function ProjectScopeBanner({ projectId, className = '' }: Props) {
  if (projectId) return null;

  return (
    <div
      className={`flex items-start gap-2 rounded-lg border border-amber-200 bg-amber-50 px-3 py-2 text-[11px] text-amber-900 ${className}`}
      role="status"
    >
      <FiInfo className="w-3.5 h-3.5 shrink-0 mt-0.5" />
      <p>
        <strong>No project selected.</strong> Pick a project in the sidebar to see its full backlog, board, and reports.
        Cross-project views are limited to the most recent 500 work items.
      </p>
    </div>
  );
}
